import "./StatCard.css";
import "../../index.css";
import { config } from "../../config.js";

const StatCard = (props) => {
    const { title, value, index } = props.data;

    return (
        <div className="stat-card">
            <div className="card-container p-4">
                <div className="border-l-4" style={ index !== null ? { borderColor: config.colorArr[index]  } : { borderColor: "#fbc02d" } }>
                    <div className="ml-4">
                        <div className="text-sm text-color capitalize">{ title }</div>
                        <div className="text-xl value-color font-bold mt-2">{ value }</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StatCard;